import * as _ from 'underscore';

import { IWidget } from './Interfaces';

export interface ICallback {
    (): void;
}

const contexts: {
    [id: number]: {
        initCount: number;
        destroyCount: number;
        init: {
            [id: number]:
                | boolean
                | {
                      priority?: number;
                      callback?: ICallback;
                  };
        };
        destroy: {
            [id: number]:
                | boolean
                | {
                      priority?: number;
                      callback?: ICallback;
                  };
        };
    };
} = {};

let id = 1;

function createContext() {
    return {
        init: {},
        initCount: 0,

        destroy: {},
        destroyCount: 0
    };
}

function handleInit(id: number) {
    const context = contexts[id];
    if (context == null) {
        return;
    }

    if (context.initCount === 0) {
        _.chain(context.init)
            .values()
            .compact()
            .sortBy((obj: any) => {
                return -obj.priority;
            })
            .each((obj: any) => {
                const callback = obj.callback;
                if (callback == null) {
                    return;
                }

                callback();
            });
    }
}

function handleDestroy(id: number) {
    const context = contexts[id];
    if (context == null) {
        return;
    }

    if (context.destroyCount === 0) {
        _.chain(context.destroy)
            .values()
            .compact()
            .sortBy('priority')
            .each((obj: any) => {
                const callback = obj.callback;
                if (callback == null) {
                    return;
                }

                callback();
            });
    }
}

export function createWorkspaceContext() {
    var _id = id;

    contexts[_id] = createContext();

    id += 1;

    return _id;
}

export function destroyWorkspaceContext(id: number) {
    delete contexts[id];
}

export function registerWidgetsInit(id: number, widgets: IWidget[]) {
    var context = contexts[id];
    if (context == null) {
        return;
    }

    context.init = {};
    context.initCount = widgets.length;

    _.each(widgets, (obj) => {
        var key = obj.id || obj.cid;

        context.init[key] = false;
    });
}

export function registerWidgetsDestroy(id: number, widgets: IWidget[]) {
    var context = contexts[id];
    if (context == null) {
        return;
    }

    context.destroy = {};
    context.destroyCount = widgets.length;

    _.each(widgets, (obj) => {
        var key = obj.id || obj.cid;

        context.destroy[key] = false;
    });
}

export function widgetInit(id: number, widget: number, callback: ICallback, priority: number = 0) {
    var context = contexts[id];
    if (context == null) {
        return;
    }

    if (context.init == null || context.init[widget] !== false) {
        callback();
    } else {
        context.init[widget] = {
            callback: callback,
            priority: priority
        };

        context.initCount -= 1;

        handleInit(id);
    }
}

export function widgetDestroy(id: number, widget: number, callback, priority: number = 0) {
    const context = contexts[id];
    if (context == null) {
        return;
    }

    if (context.destroy == null || context.destroy[widget] !== false) {
        callback();
    } else {
        context.destroy[widget] = {
            callback: callback,
            priority: priority
        };

        context.destroyCount -= 1;

        handleDestroy(id);
    }
}

export function widgetFailInit(contextID: number, widgetID: number) {
    const context = contexts[contextID];
    if (context == null) {
        return;
    }

    if (context.init != null && context.init[widgetID] === false) {
        context.init[widgetID] = null;
        context.initCount -= 1;

        handleInit(contextID);
    }
}

export function widgetFailDestroy(id: number, widget: number) {
    const context = contexts[id];
    if (context == null) {
        return;
    }

    if (context.destroy != null && context.destroy[widget] === false) {
        context.destroy[widget] = null;
        context.destroyCount -= 1;

        handleDestroy(id);
    }
}
